import BottomSheet from './BottomSheet';

export { default as BottomSheet } from './BottomSheet';
export { BOTTOM_SHEET_ANIMATION_DURATION } from './constants';

export default BottomSheet;
